import { Pipe, PipeTransform } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingBillingTypeDocumentProps, BookingBillingDocumentRules } from '@app/entities/booking-documents';
import { BillingPersonType } from '@booking/entities/billing-person-types';
import { BillingFacade } from '@billing/billing.facade';
import { isValidBilligByConfigModule } from '@billing/mappers/valid-billing.mapper';
import { AppFacade } from '@app/app.facade';

@Pipe({
  name: 'billingTypeDocuments',
  standalone: false
})
export class BillingDocumentsPipe implements PipeTransform {

  constructor(
    private facade: BillingFacade,
    private appFacade: AppFacade,
  ) { }

  transform(billingType: BillingPersonType, country: string): Observable<BookingBillingTypeDocumentProps[]> {
    return zip(
      this.facade.bookingType$,
      this.appFacade.documentAssets$.pipe(map(documents => documents?.BILLING && documents.BILLING[billingType] ?
        documents.BILLING[billingType] : []))
    ).pipe(
      map(([bookingType, documents]) => documents.filter(_document => {
        const validations = _document?.VALIDATIONS?.DOCUMENT_BUSINESS_RULES_BY_MODULES &&
          _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] ?
          _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] :
          {} as BookingBillingDocumentRules;
        return isValidBilligByConfigModule(country, validations);
      }))
    );
  }
}
